var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteAccessApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12C15 10.8954 15.8954 10 17 10H22C23.1046 10 24 10.8954 24 12V23H19.5C18.1193 23 17 24.1193 17 25.5C17 26.8807 18.1193 28 19.5 28H24C24 29.1046 23.1046 30 22 30H17C15.8954 30 15 29.1046 15 28V12ZM17 13C17 12.4477 17.4477 12 18 12H20.5C21.0523 12 21.5 12.4477 21.5 13C21.5 13.5523 21.0523 14 20.5 14H18C17.4477 14 17 13.5523 17 13ZM17.75 17.5C18.1642 17.5 18.5 17.1642 18.5 16.75C18.5 16.3358 18.1642 16 17.75 16C17.3358 16 17 16.3358 17 16.75C17 17.1642 17.3358 17.5 17.75 17.5ZM21.5 16.75C21.5 17.1642 21.1642 17.5 20.75 17.5C20.3358 17.5 20 17.1642 20 16.75C20 16.3358 20.3358 16 20.75 16C21.1642 16 21.5 16.3358 21.5 16.75ZM17.75 20.5C18.1642 20.5 18.5 20.1642 18.5 19.75C18.5 19.3358 18.1642 19 17.75 19C17.3358 19 17 19.3358 17 19.75C17 20.1642 17.3358 20.5 17.75 20.5ZM21.5 19.75C21.5 20.1642 21.1642 20.5 20.75 20.5C20.3358 20.5 20 20.1642 20 19.75C20 19.3358 20.3358 19 20.75 19C21.1642 19 21.5 19.3358 21.5 19.75Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24C18.6716 24 18 24.6716 18 25.5C18 26.3284 18.6716 27 19.5 27H28.5C29.3284 27 30 26.3284 30 25.5C30 24.6716 29.3284 24 28.5 24H19.5Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteAccessApartment);
export default __webpack_public_path__ + "static/media/remote-access-apartment.dcd0f391bccd0eb96643693ba70325e2.svg";
export { ForwardRef as ReactComponent };